import React from "react";
import { Navigate, useLocation } from "react-router-dom";

interface Props {
  children: React.ReactNode;
}

const PrivateAuth: React.FC<Props> = ({ children }: Props) => {
  const location = useLocation();
  const token = localStorage.getItem("UserRecord");
  if (!token && location?.pathname === "/save-configuration") {
    const path = `/login?redirect_url=/save-configuration${location?.search}`;
    return <Navigate to={path} replace />;
  }
  return token ? <>{children}</> : <Navigate to="/" replace />;
};

export default PrivateAuth;
